import React from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { TextDisplay } from "components/display-data";
import DownloadTxtButton from "../../../../components/buttons/download-txt-button/download-txt-button";

const SourceAdvancedInfo = ({ 
	source, 
	intl, 
	sourceOperationCheckServerReport,
	sourceOperationCheckCurrentConnections,
	sourceOperationCheckCurrentCodifications,
	sourceOperationCheckRecordingsInProgress,
	sourceLog,
  dateText,
 }) => {
  return (
    <DataGrid>
      {sourceOperationCheckServerReport && <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "source.sourceOperationCheckServerReport" })}>{<DownloadTxtButton data={sourceOperationCheckServerReport} filename={`${source.serial}-${dateText}-server-report`} />}</TextDisplay>
      </DataGridItem>}
		  {sourceLog && <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "source.sourceLog" })}>{<DownloadTxtButton data={sourceLog} filename={`${source.serial}-${dateText}-camera-log`} />}</TextDisplay>
      </DataGridItem>}
     <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "source.sourceOperationCheckCurrentCodifications" })}>{`${sourceOperationCheckCurrentCodifications}`}</TextDisplay>
      </DataGridItem>
     <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "source.sourceOperationCheckCurrentConnections" })}>{`${sourceOperationCheckCurrentConnections}`}</TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "source.sourceOperationCheckRecordingsInProgress" })}>{`${sourceOperationCheckRecordingsInProgress}`}</TextDisplay>
      </DataGridItem>
    </DataGrid>
  );
};
export default SourceAdvancedInfo;
